import { useQuery, type UseQueryResult } from '@tanstack/react-query';
import { api } from '@/lib/api';
import type { AgendaMedicoResponse } from '@/types/api';

export function useAgendaMedico(
  data: string,
  cdPaciente?: number,
): UseQueryResult<AgendaMedicoResponse, Error> {
  const pacienteQuery = cdPaciente ? `&cd_paciente=${cdPaciente}` : '';

  return useQuery({
    queryKey: ['agenda-medico', data, cdPaciente ?? null],
    queryFn: ({ signal }) =>
      api.get<AgendaMedicoResponse>(
        `/api/agenda/medico?data=${data}${pacienteQuery}`,
        { signal },
      ),
    enabled: !!data,
    refetchInterval: 60_000,
    staleTime: 30_000,
  });
}
